import type { FC } from 'react';
import { useToolCollapseState } from '../useToolCollapseState';
import { PlacesToolComponent } from './placesTool.component';

export const PlacesToolContainer: FC = () => {
  const { isToolCollapsed } = useToolCollapseState();

  return (
    <PlacesToolComponent
      isLegendMode={isToolCollapsed}
    />
  );
};
